import ApiRepository from "@/core/ApiRepository";

// Xuất excel cho trang danh sách.
// Trang dùng mixin cần: ref="datatable" trên BaseDatatable (có method getExportParams() trả về {filters, company_id, total})
// và khai báo data export_api (vd: '/_api/contractor') có 2 api: <export_api>/export hoặc export_path, <export_api>/check_export_file
export default {
  data() {
    return {
      export_limit: 2000,
      showExportDialog: false,
      exporting_excel: false,
    }
  },
  methods: {
    clickExportExcel() {
      var params = this.$refs.datatable.getExportParams();
      if (params.total > this.export_limit) {
        this.showExportDialog = true;
        return;
      }
      this.exportExcel();
    },
    confirmExportExcel() {
      this.showExportDialog = false;
      this.exportExcel();
    },
    async exportExcel() {
      var token = this.$store.getters.token ? this.$store.getters.token : null
      var params = this.$refs.datatable.getExportParams();
      if (!token || !params.company_id || this.exporting_excel) {
        return
      }
      const headers = {
        "Authorization": "Bearer "+token,
      };
      this.exporting_excel = true
      this.$commonFuction.is_loading(true);
      try {
        // api trả về path file trước, sau đó 3s gọi check 1 lần cho tới khi file export xong
        var {data} = await ApiRepository.post(this.export_api + '/' + this.export_path, {filters: params.filters, company_id: params.company_id}, {headers});
        var path = data.data ? data.data.path : null
        if (!path) {
          throw new Error('no path')
        }
        var finished = false
        while (!finished) {
          await new Promise(resolve => setTimeout(resolve, 3000))
          var res = await ApiRepository.post(this.export_api + "/check_export_file", {path: path, company_id: params.company_id}, {headers});
          var result = res.data.data ?? {}
          if (result.status == 'done') {
            finished = true
            // tải file về luôn, không mở tab mới
            var link = document.createElement('a')
            link.href = result.linkExcel
            link.download = ''
            link.style.display = 'none'
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
          } else if (result.status == 'error') {
            throw new Error('export error')
          }
        }
      } catch (e) {
        console.error("Lỗi xuất excel:", e)
        this.$toast.add({ severity: 'error', summary: 'Lỗi', detail: 'Xuất file excel thất bại', life: 5000 })
      } finally {
        this.$commonFuction.is_loading(false);
        this.exporting_excel = false
      }
    },
  },
}
